<template>
  <v-container id="roles-forms" fluid>
    <base-material-card color="#ac8a2e" icon="mdi-book-lock" inline class="px-5 py-3" title="Roles">
      <template v-if="$can('M_roles_edita')" v-slot:after-title>
        <v-btn color="#ac8a2e" dark icon @click="dialog = true">
          <v-icon large color="#ac8a2e">
            mdi-lock-open-plus-outline
          </v-icon>
        </v-btn>
      </template>
      <v-data-table
        :headers="headers"
        :items="roles"
        item-key="Name"
      >
        <template v-slot:[`item.permisos`]="{ item }">
          <v-select v-model="item.permissions" :items="item.permissions" append-icon="" color="gold" multiple readonly>
            <template v-slot:selection="{ item }">
              <v-chip color="gold" outlined text-color="TextChipColor">
                {{ item }}
              </v-chip>
            </template>
          </v-select>
        </template>
        <template v-if="$can('M_roles_edita')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="editItem(item)">
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small class="mr-2" v-bind="attrs" v-on="on" @click.stop="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>

    <v-dialog v-model="dialog" persistent max-width="750px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
          <v-tooltip color="transparent">
            <template v-slot:activator="{ on, attrs }">
              <v-icon large class="mr-2" v-bind="attrs" v-on="on">
                mdi-information
              </v-icon>
            </template>
            <v-card color="white">
              <v-card-title>
                Informacion útil sobre permisos
              </v-card-title>
              <v-card-text>
                <p class="infoPa">
                  El menú "consultas profesionales", es accesible para todos los usuarios, la configuración de permisos en los roles
                </p>
                <p class="infoPa">
                  variara el listado de consultas/turnos que puede visualizar el usuario:
                </p>
                <p class="infoPa">
                  - Sí el usuario es un jugador, solo ve sus consultas/turnos.
                </p>
                <p class="infoPa">
                  - Sí el usuario es un staff con cargo medico, vera las consultas/turnos que tenga asignadas/os.
                </p>
                <p class="infoPa">
                  - Sí el usuario es staff con cargo scout, vera las consultas/turnos que tenga asignadas/os.
                </p>
                <p class="infoPa">
                  -M_consultas_profesionales_todas: quien tenga dicho permiso, podrá visualizar todas las consultas existentes,
                </p>
                <p class="infoPa">
                  sin importar el tipo de usuario que sea.
                </p>
                <p class="infoPa">
                  -M_consulta_turno: permite al usuario solicitar un turno.
                </p>
                <p class="infoPa">
                  -M_consultas_gestion: habilita acciones en consultas profesionales (alta, baja, edición)
                </p>
                <p class="infoPa">
                  El comportamiento de M_legales_todos y M_viáticos_todos, es igual a M_consultas_profesionales_todas
                </p>
                <p class="infoPa">
                  quien tenga el/los permisos podrá visualizar todos los litigios/viáticos, si no, solo los
                </p>
                <p class="infoPa">
                  litigios/viáticos que tenga asignados.
                </p>
              </v-card-text>
            </v-card>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container class="ma-0 pa-0">
            <validation-observer v-slot="{ handleSubmit }">
              <form id="altaRole" @submit.prevent="handleSubmit(validateForm)">
                <v-row justify="center">
                  <v-col cols="12">
                    <v-row>
                      <v-col cols="12">
                        <validation-provider v-slot="{ errors }" name="role" rules="max:25">
                          <v-text-field v-model="dataForm.name" color="#ac8a2e" :error-messages="errors" name="role" label="Role" />
                        </validation-provider>
                      </v-col>
                    </v-row>
                    <v-divider />
                    <v-row class="mt-4 pl-2">
                      <v-col v-for="permiso in permisos" :key="permiso" cols="12" md="4" class="pa-0 ml-0">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-checkbox v-model="dataForm.permissions" color="info" class="pa-0 ma-0" :value="permiso">
                              <span slot="label" v-bind="attrs" :class="{'black--text': !isDarkMode}" v-on="on">
                                {{ permiso }}
                              </span>
                            </v-checkbox>
                          </template>
                          <span>{{ descripcionPermiso(permiso) }}</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </form>
            </validation-observer>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="close">
                Cancelar
              </v-btn>
              <v-btn color="blue darken-1" text form="altaRole" type="submit" @click="dialog = false">
                Guardar
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        headers: [
          { text: 'Nombre role', sortable: true, value: 'name', align: 'start', width: '200px' },
          { text: 'Permisos', value: 'permisos', sortable: false, align: 'start' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end', width: '100px' },
        ],
        dialogDelete: false,
        dialog: false,
        editedIndex: -1,
        dataForm: {
          id: 0,
          name: '',
          permissions: [],
        },
        roles: [],
        permisos: [],
        permisosDesc: [],
      }
    },
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuevo role' : 'Editar role'
      },
      mode () {
        return this.editedIndex === -1 ? 'new' : 'edit'
      },
      isDarkMode: function () {
        return this.$store.getters.getDarkMode
      },
    },
    created () {
      this.getRoles()
      this.getPermisos()
      this.getDescripciones()
    },
    methods: {
      TextChipColor: function () {
        return this.isDarkMode ? 'while' : 'black'
      },
      descripcionPermiso (permiso) {
        if (this.permisosDesc.length !== 0) {
          const found = this.permisosDesc.find(element => element.name === permiso)
          return (found.descripcion !== null) ? found.descripcion : ''
        }
        return ''
      },
      editItem (item) {
        this.editedIndex = this.roles.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialog = true
      },
      deleteItem (item) {
        this.editedIndex = this.roles.indexOf(item)
        this.dataForm = Object.assign({}, item)
        this.dialogDelete = true
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.dataForm = Object.assign({}, null)
          this.editedIndex = -1
        })
      },
      ordenarPermisos () {
        this.permisos.sort()
      },
      getRoles: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/role_get' }).then(response => { this.roles = response })
      },
      getPermisos: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/permisos_get' }).then(response => { this.permisos = response; this.ordenarPermisos() })
      },
      getDescripciones: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/permisos_get_descripc' }).then(response => { this.permisosDesc = response })
      },
      validateForm (scope) {
        this.enviarRole()
      },
      enviarRole: async function () {
        const method = (this.mode === 'new') ? 'post' : 'put'
        await this.$http({
          method: method,
          url: '/api/role_agregar',
          data: {
            ...this.dataForm,
          },
          headers: { Authorization: 'Bearer ' + this.$store.state.token },
        }).then(response => {
          this.close()
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Alta de role exitosa'] })
        }).catch(error => {
          this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
        })
        this.getRoles()
      },
    },

  }
</script>

<style>
.infoPa {
  font-size: small;
  padding: 0px;
  margin-bottom: 2px !important;
}
</style>
